import React from "react";
//import PropTypes from 'prop-types';
import "./eventsSkeleton.scss";
import { URLineSkeleton } from "./skeletonWidgets/lineSkeleton";
import { URButtonSkeleton } from "./skeletonWidgets/buttonSkeleton";
import { URStatusbarSkeleton } from "./skeletonWidgets/statusBarSkeleton";
function UREventsSkeleton(props: any) {
  return (
    <>
      <div className="eventSkeleton">
        <div className="btnSec">
          <URLineSkeleton className='line lineThick size30'/>
          <URButtonSkeleton className='skeletonBtn' />
        </div>
        <div className="eventsBox">
          <div className="boxFirstLine">
            <URLineSkeleton className='line lineThick size50'/>
            <URLineSkeleton className='line lineThick size5'/>
            <URButtonSkeleton className='skeletonBtn' />
          </div>
          <div className="boxSecondLine">
            <URStatusbarSkeleton className='statusBar'/>
            <URLineSkeleton className='line lineThick size50'/>
            <URButtonSkeleton className='skeletonBtn sizelg' />
          </div>
        </div>
      </div>
    </>

  );
}

export {
  UREventsSkeleton
};